import '@chenfengyuan/datepicker';
import '@chenfengyuan/datepicker/i18n/datepicker.ru-RU';
import Inputmask from 'inputmask';

export function datepickerInit() {
  const $pickers = $('.form-control-datepicker');
  if(!$pickers || $pickers.length === 0) return;

  $pickers.each((i, el) => {
    new Inputmask('99.99.9999').mask(el);

    $(el).datepicker({
      language: 'ru-RU'
    });
  });
}
